export enum PayoutOrderLockReason {
  ProviderAssignmentCron = 'provider_assignment_cron',
  TraderAssignment = 'trader_assignment',
}
